<template>
  <section class="future">
      <div class="future__content container">
				<div class="future__info-container">
					<div class="future__description --fade-in-right --delay-1" data-vertical-ivp-class="--animate">
						<h2 class="future__title">Don’t Miss out on the Future of Wellness </h2>
						<div class="future__lines">
							<hr class="line-1">
							<hr class="line-2">
						</div>
						<p>
						Onassis is currently focused on distribution of nutraceuticals and herbal-based 
						medications in the wellness sector, along with future plans for manufacturing 
						new products for this market. It has begun working with the world's top nutrition 
						experts for innovative manufacturing and marketing collaboration. The Company has 
						selected products that passed in-vitro and in-vivo clinical studies of herbal and 
						marine formulations utilized and documented by traditional and natural medicine in 
						over thousand years to ensure that its ingredients are effective. With an eye on  quality, 
						its herbs are hand-selected and reasonably sourced only from authentic medicinal material 
						cultivation areas, designed to be fully traceable from harvest to extract. Onassis is the 
						future of nutraceuticals, don’t miss this chance to join in. 
						</p>
					</div>
					<img class="future__side-img --fade-in-left --delay-1" data-vertical-ivp-class="--animate" src="../assets/future/collage-img.png" alt="Collage of product marketing">
				</div>
      </div>
  </section>
</template>

<script>
export default {
  name: 'Future',
  data () {
    return {
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../styles/components/future.scss";
</style>
